module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FM-Head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('a', {
    attrs: {
      "href": "#/02_Fm01"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('a', {
    attrs: {
      "href": "#/03_Fm02"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('a', {
    attrs: {
      "href": "#/04_Fm03"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca"
  }, [_c('a', {
    attrs: {
      "href": "#/05_Fm04"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06_Part01"
    }
  }, [_c('span', {
    staticClass: "semibold"
  }, [_c('span', {
    staticClass: "Tc1"
  }, [_vm._v("I")]), _vm._v(" FROM ARMY BRAT TO VIETNAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Chapter01"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("1")]), _vm._v(" From Army Brat to Basic Training")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Chapter02"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("2")]), _vm._v(" US Army Intelligence School")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Chapter03"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("3")]), _vm._v(" On to Vietnam")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter04"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("4")]), _vm._v(" My New Home")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "semibold"
  }, [_c('span', {
    staticClass: "Tc1"
  }, [_vm._v("II")]), _vm._v(" “CRY HAVOC …”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("5")]), _vm._v(" The Laos Prelude")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("6")]), _vm._v(" Foundations of the Easter Offensive of 1972")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("7")]), _vm._v(" Ignoring the Signs—The Buildup and Launch of the Easter Offensive")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("8")]), _vm._v(" Did Intelligence Fail Again?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("9")]), _vm._v(" Cut and Run: What ARVN called “Mobility”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("10")]), _vm._v(" Too Many Tanks")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("11")]), _vm._v(" In Retrospect … A Brief Look Back")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("12")]), _vm._v(" Prologue to Surrender—Camp Carroll")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("13")]), _vm._v(" The Bridge at Dong Ha")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("14")]), _vm._v(" BAT-21")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("15")]), _vm._v(" Independent NVA Regiment Actions in I Corps Area")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "semibold"
  }, [_c('span', {
    staticClass: "Tc1"
  }, [_vm._v("III")]), _vm._v(" NOT A CRYSTAL BALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("16")]), _vm._v(" National Intelligence and Surveillance Technologies")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("17")]), _vm._v(" Theater and Area Commands")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("18")]), _vm._v(" Diversions and Deceptions at the Onset")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("19")]), _vm._v(" 571st Military Intelligence Detachment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("20")]), _vm._v(" Observations, Reflections, and Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("21")]), _vm._v(" Lessons Disregarded")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("22")]), _vm._v(" Early Lessons, Still Disregarded")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Tc"
  }, [_vm._v("23")]), _vm._v(" Last Days and Further Assignments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toct"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/46_Bm15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/47_Bm16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bde6ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01_Contents.vue
// module id = 72
// module chunks = 0